module.exports = __webpack_public_path__ + "static/media/2.60b609c0.png";